import { render, staticRenderFns } from "./icon-selector-button.vue?vue&type=template&id=3024a21d&scoped=true&"
import script from "./icon-selector-button.vue?vue&type=script&lang=ts&"
export * from "./icon-selector-button.vue?vue&type=script&lang=ts&"
import style0 from "./icon-selector-button.vue?vue&type=style&index=0&id=3024a21d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3024a21d",
  null
  
)

export default component.exports